import { createAction } from 'lib/store-utils';
import { FormattedErrors } from '../../../type/models';
import { GetApprovalsPayload, GetApproversSuccessPayload } from './types';

export const BOX_USER_APPROVALS_MODAL_GET_APPROVALS = createAction<GetApprovalsPayload>('User Approvals Modal / get approvals');
export const BOX_USER_APPROVALS_MODAL_GET_APPROVALS_REQUEST = createAction('User Approvals Modal / get approvals request');
export const BOX_USER_APPROVALS_MODAL_GET_APPROVALS_SUCCESS = createAction<GetApproversSuccessPayload>('User Approvals Modal / get approvals success');
export const BOX_USER_APPROVALS_MODAL_GET_APPROVALS_FAILURE = createAction<FormattedErrors>('User Approvals Modal / get approvals failure');
